export const PunchoutMode = {
  OCI: "OCI",
  CXML: "CXML",
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PunchoutMode = (typeof PunchoutMode)[keyof typeof PunchoutMode];

interface PunchoutConfig {
  placeOrder: string;
  cancel: string;
}

export const PUNCHOUT_CONFIG_MAP: Record<PunchoutMode, PunchoutConfig> = {
  [PunchoutMode.OCI]: {
    placeOrder: "/punchout/oci/requisition",
    cancel: "/punchout/oci/cancel",
  },
  [PunchoutMode.CXML]: {
    placeOrder: "/punchout/cxml/requisition",
    cancel: "/punchout/cxml/cancel",
  },
};

export function isPunchoutEnabled(): boolean {
  return !!window.SCHA.config.punchoutMode;
}

export function getPunchoutConfig(): PunchoutConfig {
  return PUNCHOUT_CONFIG_MAP[window.SCHA.config.punchoutMode as PunchoutMode];
}
